import GroupsCalls from '../api/GroupCalls';
import { actionsDevices } from '../../commander/slice/devicesSlice';
import { AppDispatch, AppStore } from '../../store.model';
import { LABEL_NEW } from '../../commander/api/Constants';
import { fetchDevicesByIds } from '../../commander/actions/thunks';
import { GroupAPI } from '../api/GroupAPI';
import { CommanderAPI } from '../../commander/api/CommanderAPI';

/**
 * Put group devices: call the backend to update a group adding a devices
 * @param string groupId
 * @param array devicesId
 */
export const putGroupAddDevices =
  (groupId: string, devicesIds: string[]) => async (dispatch: AppDispatch) => {
    const groupsCalls = new GroupsCalls();
    await groupsCalls.putGroupAddDevices(groupId, devicesIds);

    // for each devices add labels new and fetch it
    devicesIds.forEach((deviceId) =>
      dispatch(actionsDevices.addLabel({ label: LABEL_NEW, deviceId, groupId }))
    );
    await dispatch(
      GroupAPI.endpoints.getGroups.initiate(undefined, {
        forceRefetch: true,
      })
    ).unwrap();
  };

/**
 * Put group devices: call the backend to update a group adding a devices
 * @param string groupId
 * @param array devicesId
 */
export const patchGroupDevices =
  (groupId: string, devicesIds: string[]) =>
  async (dispatch: AppDispatch, getState: AppStore['getState']) => {
    const groupsCalls = new GroupsCalls();
    await groupsCalls.patchGroupDevices(groupId, devicesIds);

    await dispatch(fetchDevicesByIds(devicesIds));
    await dispatch(
      GroupAPI.endpoints.getGroups.initiate(undefined, {
        forceRefetch: true,
      })
    ).unwrap();
  };
